import React, { useState } from 'react'

import { Box, Button, Card, Heading, Text } from '@myxplor/stardust'

import { ServiceDetail } from './types'
import ContactEmailModal from './ContactEmailModal'

interface Props {
  service: ServiceDetail
  onRefreshServiceData(): void
}

const Plans = ({ service, onRefreshServiceData }: Props) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  const onEmailChange = async () => {
    setModalOpen(false)
    onRefreshServiceData()
  }

  return (
    <Card>
      <Box display="flex" flexDirection="column">
        <Box alignItems="center" display="flex" justifyContent="space-between" padding="small">
          <Heading level={5}>Contact Email</Heading>
          <Button onClick={() => setModalOpen(true)}>
            {service.contact_email ? 'Change Contact Email' : 'Set Contact Email'}
          </Button>
        </Box>
        <Box borderColor="lowestEmphasis" border="1px solid" padding="small">
          <Text>{service.contact_email || 'This service has no contact email'} </Text>
        </Box>
      </Box>
      <ContactEmailModal
        isOpen={isModalOpen}
        service={service}
        onCancel={() => setModalOpen(false)}
        onSave={onEmailChange}
      />
    </Card>
  )
}

export default React.memo(Plans)
